module.exports = __webpack_public_path__ + "img/116.9d2e94a1.png";